/**
 * DisplayItem object.
 *
 * @typedef {Object} DisplayItem
 * @namespace
 *
 * @memberof Common.Model.Entity
 *
 * @property {Integer} id The item id.
 * @property {String} extId The external item id.
 * @property {Common.Model.Entity.DisplayItem.Meta} meta Object storing the associated meta information.
 * @property {Common.Model.Entity.DisplayItem.Content} content Object storing the associated content information.
 * @property {Common.Model.Entity.DisplayItem.Cta} cta Object storing the associated CTA information.
 * @property {Common.Model.Entity.DisplayItem.Strategy} strategy Object storing the associated strategy information.
 * @property {Common.Model.Entity.DisplayItem.Review} review Object storing the associated review information.
 * @property {Common.Model.Entity.DisplayItem.Ref} ref Object storing the associated refs.
 * @property {Common.Model.Entity.DisplayItem.Contest} contest Object storing the associated contest information.
 * @property {Common.Model.Entity.DisplayItem.Embed} embed Object storing the associated embed information.
 * @property {Common.Model.Entity.DisplayItem.Profile} profile Object storing the associated actions that can be performed on this item (voting, sharing etc.)
 * @property {Common.Model.Entity.DisplayItem.Assets} assets Object storing the associated image assets for the item (main/thumbnail etc).
 * @property {Common.Model.Entity.DisplayItem.Actions} actions Object storing the associated users information.
 */
class DisplayItem {
  constructor(
    id,
    extId,
    meta,
    content,
    cta,
    strategy,
    review,
    ref,
    contest,
    embed,
    profile,
    assets,
    actions,
    originalContent
  ) {
    // Ids.
    this.id = id;
    this.extId = extId;

    // Meta.
    this.meta = meta;

    // Content.
    this.content = content;

    // CTA.
    this.cta = cta;

    // Strategies.
    this.strategy = strategy;

    // Reviews (Bazaarvoice).
    this.review = review;

    // Refs.
    this.ref = ref;

    // Contest/voting.
    this.contest = contest;

    // Embed.
    this.embed = embed;

    // Profile.
    this.profile = profile;

    // Assets.
    this.assets = assets;

    // Actions.
    this.actions = actions;

    this.originalContent = originalContent;
  }
}

export default DisplayItem;
